<template>
    <DefaultTemplate :model="model">
        <div class="container">
            <div class="mt-12 mb-8">
                <Breadcrumbs :breadcrumbs="model.breadcrumbs" className="text-grey-400" />
            </div>

            <div class="block lg:flex">
                <div class="w-full pr-0 lg:pr-4">
                    <article class="p-4 md:px-10 md:py-4 lg:px-20 lg:py-10 mb-4 bg-white">
                        <h1 v-epi-edit="'Name'" class="mb-2">
                            {{ model.name }}
                        </h1>

                        <hr class="my-4 lg:my-4" />

                        <div v-epi-edit="'MainBody'" id="main-body" class="main-body my-4 article pt-4" v-html="this.model.mainBody" />

                        <InteractiveMatrix :rows="this.model.rows" :columns="this.model.columns"/>

                        <div v-epi-edit="'SecondaryBody'" id="seconday-body" class="main-body my-4 article" v-html="this.model.secondaryBody" />
                    </article>
                </div>
            </div>
        </div>
    </DefaultTemplate>
</template>

<script>
import Breadcrumbs from '@/Scripts/components/organisms/Breadcrumbs/breadcrumbs.vue';
import InteractiveMatrix from '@/Scripts/components/blocks/InternactiveMatrix/InteractiveMatrix.vue';

export default {
    props: ['model'],
    components: {
        Breadcrumbs,
        InteractiveMatrix
    }
};
</script>
